import { Skeleton } from "@/components/ui/skeleton";

const CompanySnapshotSkeleton = () => (
  <div className="space-y-4">
    <div>
      <div className="flex items-center gap-2 text-xs font-semibold">
        <Skeleton className="h-4 w-4 rounded-full" />
        <Skeleton className="h-3 w-32" />
      </div>
      <div className="mt-2 space-y-2 rounded-radius border border-border bg-background p-3">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    </div>
    <div>
      <div className="flex items-center gap-2 text-xs font-semibold">
        <Skeleton className="h-4 w-4 rounded-full" />
        <Skeleton className="h-3 w-28" />
      </div>
      <div className="mt-2 space-y-2 rounded-radius border border-border bg-background p-3">
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    </div>
    <div>
      <div className="flex items-center gap-2 text-xs font-semibold">
        <Skeleton className="h-4 w-4 rounded-full" />
        <Skeleton className="h-3 w-32" />
      </div>
      <div className="mt-2 rounded-radius border border-border bg-background p-3">
        <Skeleton className="h-5 w-32" />
      </div>
    </div>
    <div>
      <div className="flex items-center gap-2 text-xs font-semibold">
        <Skeleton className="h-4 w-4 rounded-full" />
        <Skeleton className="h-3 w-40" />
      </div>
      <div className="mt-2 rounded-radius border border-border bg-background p-3">
        <Skeleton className="h-5 w-36" />
      </div>
    </div>
  </div>
);

export default CompanySnapshotSkeleton;
